export const Error = () => {
  return <div className="error">sorry, user not found</div>;
};
